import { all, fork } from "redux-saga/effects";

//auth
import authSaga from "./auth/saga";
import layoutSaga from "./layout/saga";
import myAccountSaga from './My-Account/saga'

export default function* rootSaga() {
  yield all([
    fork(authSaga),
     fork(layoutSaga) ,
     fork(myAccountSaga)
    ]);
}
